"use client"
import React from 'react';
import { Button, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';


//import myLoader from 'components/image-loader'


const Logo = () => {
    const navi = useNavigate();

    return (
        <Button
            onClick={() => navi('/')}
            size="large"
            edge="start"
            color="inherit"
        >
            <CardMedia
                image={'/tirefax.png'}
                sx={{
                    margin: {
                        xs: "0px",
                        md: "25px"
                    },
                    width: "160px",
                    height: "76px"
                }}
                width={160}
                height={76}
                alt="logo"
            />
        </Button>
    )
}

export default Logo;